import React, { useEffect, useState } from 'react';
import groupService from 'src/services/group.service';
import BrandAutocomplete, { createOptionsFromArr } from '.';

function GroupAutocomplete({
  onChange,
  value,
  name,
  label,
  multiple = false,
  createApiCall = null,
  deleteApiCall = null,
  deleteOnClear = false,
  noLabel
}) {
  const [options, setOptions] = useState([]);

  useEffect(() => {
    (async () => {
      const { data } = await groupService.get();

      setOptions(data || []);
    })();
  }, []);
  return (
    <BrandAutocomplete
      label={label ?? 'Groups'}
      noLabel={noLabel}
      placeholder="Select Groups..."
      onChange={onChange}
      createApiCall={createApiCall}
      deleteApiCall={deleteApiCall}
      deleteOnClear={deleteOnClear}
      value={value}
      multiple={multiple}
      name={name ?? 'Groups'}
      options={createOptionsFromArr(options, 'name', 'id')}
    />
  );
}

export default GroupAutocomplete;
